import React, { useContext, useEffect, useRef, useState } from "react";
import {
    Button,
    Input,
    Modal,
    Space,
    Table,
    Tag,
    Tooltip,
    Typography,
} from "antd";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { DeleteOutlined } from "@ant-design/icons";
// api
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { context } from "./../../context/context";
import { Link } from "react-router-dom";
const PlaceTableData = () => {
    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            dataIndex === "address"
                ? record[dataIndex].address
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : dataIndex === "tags"
                ? record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : dataIndex === "province"
                ? record[dataIndex].province
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : dataIndex === "country"
                ? record[dataIndex].name
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : dataIndex === "city"
                ? record["city"]?.name &&
                  record["village"]?.name
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : dataIndex === "category"
                ? record[dataIndex].name
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    // context
    const {
        setForceUpdate,
        forceUpdate,
        setDataPlaces,
        dataPlaces,
        selectedPlaceId,
        setSelectedPlaceId,
        setTextEditorHTML,
        setLinkTags,
        setAddPhonePlace,
        setAddNamePlace,
        setAddAddressPlace,
        setPlaceId,
        setSelectedCategoryId,
        setSelectedPlaceProvinceId,
        setEditedCity,
        setEditedProvince,
        setEditedCountry,
        setEditedCategory,
        setEditedSubCategory,
        setIsCountrySelected,
        setSelectedCityId,
        setSelectedCountry,
        setSelectedProvince,
    } = useContext(context);
    const [deleteModalOpen, setDeleteIsModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Place/`)
            .then((res) => {
                setLoading(false);
                setDataPlaces(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate]);
    const handleRowClick = (record) => {
        setSelectedPlaceId(record._id);
    };
    const handleDelete = () => {
        setDeleteIsModalOpen(true);
    };

    const handleOk = () => {
        http.delete(`${config.parkopoloApi}/api/Place/${selectedPlaceId}`)
            .then((res) => {
                setForceUpdate(11);
                console.log(res.data.success);
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
            });
        setDeleteIsModalOpen(false);
        setForceUpdate(15);
    };
    const handleCancel = () => {
        setDeleteIsModalOpen(false);
    };
    const handleEditPlace = (record) => {
        setAddNamePlace(record.title);
        setAddPhonePlace(record.phone);
        setPlaceId(record._id);
        setLinkTags(record.links);
        setTextEditorHTML(record.data);
        setAddAddressPlace(record.address.address);
        setSelectedPlaceProvinceId(record.province._id);
        setEditedCity(record.city ? record.city : null);
        setAddNamePlace(record.title);
        setAddPhonePlace(record.phone);
        setLinkTags(record.links);
        setTextEditorHTML(record.data);
        setEditedProvince(record.province);
        setEditedCountry(record.country);
        setEditedCategory(record.category);
        setEditedSubCategory(
            record.subCategory ? record.subCategory._id : null
        );
        if (!record.city) setIsCountrySelected(false);
        setSelectedCategoryId();
        setSelectedCityId();
        setSelectedCountry();
        setSelectedProvince();
    };
    const columns = [
        {
            title: "عنوان",
            dataIndex: "title",
            width: "10%",
            ...getColumnSearchProps("title"),
        },
        {
            title: "تگ",
            dataIndex: "tags",
            ...getColumnSearchProps("tags"),
            width: "10%",
            render: (_, { tags }) => (
                <>
                    {tags.map((t) => {
                        return <Tag key={t}>{t.toUpperCase()}</Tag>;
                    })}
                </>
            ),
        },
        {
            title: "آدرس",
            dataIndex: "address",
            ...getColumnSearchProps("address"),
            render: (_, { address }) => (
                <Tooltip title={address.address}>
                    <Typography.Paragraph style={{ cursor: "pointer" }}>
                        {address.address.slice(0, 25)}
                        {address.address.length > 25 ? "..." : null}
                    </Typography.Paragraph>
                </Tooltip>
            ),
        },
        {
            title: "استان",
            dataIndex: "province",
            width: "10%",
            ...getColumnSearchProps("province"),
            render: (_, { province }) => (
                <>
                    <Typography.Paragraph>
                        {province ? province.province : null}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "شهرستان",
            dataIndex: "country",
            width: "10%",
            ...getColumnSearchProps("country"),
            render: (_, { country }) => (
                <>
                    <Typography.Paragraph>
                        {country ? country.name : null}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "شهر/روستا",
            width: "10%",
            dataIndex: ["city", "village"],
            ...getColumnSearchProps("city"),
            render: (_, { village, city }) => (
                <>
                    <Typography.Paragraph>
                        {city ? city.name : village ? village.name : null}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "دسته بندی",
            width: "10%",
            dataIndex: "category",
            ...getColumnSearchProps("category"),
            render: (_, { subCategory, category }) => (
                <>
                    <Typography.Paragraph>
                        {category ? category.name : null}
                        {subCategory && category
                            ? `/${subCategory.name}`
                            : null}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            key: "button",
            width: "10%",
            render: (_, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={() => {
                                return handleDelete(record);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش">
                            <Link to={"/editPlace"}>
                                <Button
                                    onClick={() => {
                                        return handleEditPlace(record);
                                    }}
                                    type="primary"
                                    icon={<EditOutlined />}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                />
                            </Link>
                        </Tooltip>
                        <Tooltip title="مشاهده کامنت ها">
                            <Link to="/placeComments">
                                <Button
                                    disabled={record.comment.length === 0}
                                    onClick={() =>
                                        setSelectedPlaceId(record._id)
                                    }
                                    type="primary"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    کامنت ها
                                </Button>
                            </Link>
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];

    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={dataPlaces}
                scroll={{ x: true }}
                loading={loading}
                onRow={(record) => {
                    return {
                        onClick: () => handleRowClick(record),
                    };
                }}
            />

            <Modal
                title="حذف کامل"
                open={deleteModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="حذف"
            >
                <p>مطمئنی میخوای حذف کنی؟</p>
            </Modal>
        </>
    );
};

export default PlaceTableData;
